import {Link} from 'pepsico-ds'
export default Link
